document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.custom-mega-menu').forEach(function (menu) {
    const buttons = menu.querySelectorAll('.custom-mega-menu__sidebar-link');
    const panels = menu.querySelectorAll('.custom-mega-menu__panel');

    buttons.forEach(function (button) {
      const activate = function () {
        const panelId = button.getAttribute('data-panel');

        buttons.forEach(function (btn) {
          btn.classList.remove('is-active');
        });

        panels.forEach(function (panel) {
          panel.classList.remove('is-active');
        });

        button.classList.add('is-active');

        let panel = null;
        try {
          panel = menu.querySelector('#' + CSS.escape(panelId));
        } catch (e) {
          panel = menu.querySelector('[id="' + panelId + '"]');
        }

        if (panel) {
          panel.classList.add('is-active');
        }
      };

      button.addEventListener('mouseenter', activate);
      button.addEventListener('focus', activate);
      button.addEventListener('click', activate);
    });
  });

  const shopAllSources = Array.from(document.querySelectorAll('.custom-mega-menu__shopall'));

  shopAllSources.forEach(function (sourceLink) {
    const megaMenu = sourceLink.closest('.mega-menu');
    if (!megaMenu) return;

    const summary = megaMenu.querySelector('summary');
    if (!summary) return;

    const title = summary.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
    const href = sourceLink.getAttribute('href');
    if (!title || !href) return;

    const drawerItems = Array.from(document.querySelectorAll('.menu-drawer summary.menu-drawer__menu-item'));

    drawerItems.forEach(function (drawerSummary) {
      const drawerTitle = drawerSummary.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
      if (drawerTitle !== title) return;

      const drawerDetails = drawerSummary.closest('details');
      if (!drawerDetails) return;

      const submenu = drawerDetails.querySelector('.menu-drawer__submenu');
      if (!submenu || submenu.querySelector('.custom-mobile-shop-all')) return;

      const menuList = submenu.querySelector('.menu-drawer__menu');
      if (!menuList) return;

      const shopAllItem = document.createElement('li');
      shopAllItem.className = 'custom-mobile-shop-all-item';

      const shopAllLink = document.createElement('a');
      shopAllLink.href = href;
      shopAllLink.className = 'menu-drawer__menu-item custom-mobile-shop-all button';
      shopAllLink.textContent = 'Shop All Products';

      shopAllItem.appendChild(shopAllLink);
      menuList.appendChild(shopAllItem);
    });
  });
});
